<template>
  <div class="soluciones py-5 text-white">
    <div class="contenedor-titulo pb-4">
      <!-- <h2 class="pb-3 pt-1"> Elige la solución que más se adapte a tus necesidades</h2>  -->
      <titulo-seccion>Mira las soluciones más innovadoras</titulo-seccion>
    </div>
    <div class="row justify-content-center pb-1">
      <div
        class="col-12 col-sm-6 col-lg-4 col-xl-3 py-2 py-lg-3 px-2 px-lg-3"
        v-for="(item,index) in productosSolucion"
        :key="index"
      >
        <router-link :to="'/' + item.path">
          <div class="contenedor-solucion rounded-lg shadow py-3">
            <img :src="item.logo" :alt="item.nombre" />
            <div class="px-1 px-lg-3">
              <h1 class="py-1" :class="{'font-weight-bold' : productoPrincipal(item.id) }">{{item.nombre}}</h1>
              <p>{{item.descripcion}}</p>
            </div>
          </div>
        </router-link>
      </div>
      
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      productosSolucion: []
    };
  },
  computed: {
    ...mapState(["Productos"])
  },
  created() {
    this.obtenerProductos();
  },
  destroyed() {
    this.productosSolucion = [];
  },
  methods: {
    obtenerProductos()  {
      this.Productos.slice(0, 4).forEach(item => {
        this.productosSolucion.push(item);
      });
    },
    productoPrincipal(value) {
      if (value == 1) {
        return true;
      }
    }
  }
};
</script>
<style scoped>
.soluciones {
  padding: 0 6%;
  letter-spacing: 0.5px;
  background: rgba(255, 255, 255,1);
}
.contenedor-solucion {
  background: #fff;
  height: 100%;
  transition: transform 0.2s;
  -o-transition: transform 0.2s;
  -moz-transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
}
.contenedor-solucion:hover{
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
}
.contenedor-titulo h2 {
  font-size: calc(1.3em + 0.2vw);
  font-weight: 400;
  color: #595959;
  letter-spacing: -0.3px;
}

a:hover {
  text-decoration: none;
}

.contenedor-solucion img {
  max-width: 80%;
}
.contenedor-solucion h1 {
  margin: 0;
  letter-spacing: -0.5px;
  font-size: calc(1em + 0.8vw);
  color: #262626;
}
.contenedor-solucion p {
  color: #595959;
  line-height: 1.2;
  letter-spacing: -0.3px;
  font-size: calc(0.9em + 0.3vw);
}

@media screen and (max-width: 768px) {
  .contenedor-solucion h1 {
    font-size: calc(1.42em + 0.8vw);
  }
  .contenedor-solucion p {
    font-size: 1.35em;
  }

  .contenedor-solucion img {
    width: 260px;
  }
}
</style>